exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge-orange {\n    background-color: #ef871d;\n    color: #fff;\n}\n", ""]);

// exports
